import { loadMessages, locale } from "devextreme/localization";
import { getTranslationByLang } from "./config-devExtreme-locale";
import { setLocale } from "./localize";
export const initLibTranslation = (lang) => {
    return new Promise((resolve, reject) => {
        try {
            setLocale(lang);
            loadMessagesDevExtreme(lang);
            resolve();
        }
        catch (error) {
            reject(error);
        }
    });
};
const loadMessagesDevExtreme = (lang) => {
    const messages = getTranslationByLang(lang);
    loadMessages(messages);
    locale(lang);
};
//# sourceMappingURL=config-locale.js.map